import React from 'react';
import { HomeDataTableContext } from './HomeDataTableContext';

export default function useDataTableContext() {
  return React.useContext(HomeDataTableContext);
}
